var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"18","y1":"3","x2":"3","y2":"18","key":0}),React.createElement("line",{"x1":"3","y1":"3","x2":"18","y2":"18","key":1})]);
}

X.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 21 21","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = X;

X.default = X;
